import React from "react";

interface ServiceFormMapping {
  serviceId: number;
  form: string;
  formId: number;
}

const serviceFormMap: ServiceFormMapping[] = [
  { serviceId: 1, form: "ServiceRequest", formId: 3 },
];

export function getFormId(serviceId: number, formName: string): number | undefined {
  const entry = serviceFormMap.find(
    (m) => m.serviceId === serviceId && m.form.toLowerCase() === formName.toLowerCase()
  );
  if (!entry) {
    console.warn(`[getFormId] No formId found for serviceId=${serviceId}, formName=${formName}`);
  }
  return entry?.formId;
}